import moment from 'moment';
import { IMatch } from '../components/Matches/Matches-types';
import { IUserSearchOptions } from '../components/Users/Users-types';
import api from './api';

export function isMobileDevice() {
    return navigator.maxTouchPoints > 1 &&
        /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function formatUsername(username: string) {
    return username.length === 36 ? '[deleted]' : username;
}

export async function getUsers(options: IUserSearchOptions) {
    const page = options && options.page ? options.page : 1;
    const username = options && options.username ? options.username : '';

    let query = username ? `?username=${username}` : '';
    query += page ? `&page=${page}` : '';
    query = query.replace(/^&/, '?');

    return api.request(`/user/get${query}`);
}

export function gameHasSnapshots(game: IMatch) {
    return moment(game.createdAt).isAfter('2020-07-31 00:00:00');
}

export const sortPositions = (posA, posB) => {
	const [xA, yA] = posA.split(',').map(Number);
	const [xB, yB] = posB.split(',').map(Number);

	return xA !== xB ? xA - xB : yA - yB;
};
